import { Icon, IconButton, styled, TextFieldProps } from "@mui/material";
import { useCallback, useState } from "react";
import TextField from "./TextField";
import { useTranslation } from "../../helpers/i18n";
import { defaultFocusOutline } from "../../helpers/accessibility";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  position: "absolute",
  right: theme.spacing(1.3),
  "&.Mui-focusVisible": {
    outline: defaultFocusOutline(theme),
  },
}));

const StyledIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.text.inputDefault,
}));

type Props = Omit<TextFieldProps, "type" | "InputProps">;

export function PasswordField(props: Props) {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();

  const handlePassword = useCallback(() => {
    setShowPassword((current) => !current);
  }, []);

  return (
    <TextField
      {...props}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <StyledIconButton
            onClick={handlePassword}
            aria-label={t("accessibility_toggle_password_visibility")}
            aria-pressed={showPassword}
            disableRipple
          >
            {showPassword ? (
              <StyledIcon>visibility_off</StyledIcon>
            ) : (
              <StyledIcon>visibility</StyledIcon>
            )}
          </StyledIconButton>
        ),
      }}
    />
  );
}
